export default __webpack_public_path__ + "static/media/portfolio-spotify.cf593dad.png";